import React from 'react';

const UserMarker = ({ lat, lng }) => <div className='styleMarker-userLocation' lat={lat} lng={lng} />


export default UserMarker;